export default "__VITE_ASSET__ztQTjLfV__"